import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import FooterProfile from '../../components/footer_profile';
import PlansTable from '../../components/quantila/plans_table';
import Navbar from '../../components/navbar';
import isLoggedIn from '../../utils/isLoggedIn';
import { convertEntitiesDeep } from '../../utils/convertEntities';

const Plans = () => {
  const url = `${process.env.REACT_APP_API}/admin/quantila/plans`;
  const token = sessionStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getPlans = async () => {
    const response = await axios.get(url, {
      headers: { authorization: `Bearer ${token}` },
    });
    const nextPlans = Array.isArray(response.data)
      ? response.data
      : response.data?.plans || [];
    setPlans(convertEntitiesDeep(nextPlans));
    setLoading(false);
  };

  const deactivatePlan = async (plan) => {
    if (
      !window.confirm(
        `Deactivate the "${plan.name}" plan? Existing subscribers keep their current plan until they change it.`,
      )
    )
      return;

    try {
      const response = await axios.delete(`${url}/${plan.id}`, {
        headers: { authorization: `Bearer ${token}` },
      });
      if (response.status === 204 || response.status === 200) {
        toast.success('Plan was successfully deactivated.');
        getPlans();
      }
    } catch (error) {
      toast.error(
        convertEntitiesDeep(error.response?.data?.error || error.message),
      );
    }
  };

  useEffect(() => {
    isLoggedIn(navigate, dispatch, '/quantila/plans');
    getPlans();
  }, []);

  return isLoading ? (
    <>
      <Helmet>
        <title>Badgers SAS: Plans</title>
        <meta name='page' content='quantila plan management' />
      </Helmet>
      <div className='loading'>
        <img src='/img/loading.gif' alt='Loading' className='loading-img' />
      </div>
    </>
  ) : (
    <>
      <Helmet>
        <title>Badgers SAS: Plans</title>
        <meta name='page' content='quantila plan management' />
      </Helmet>
      <Navbar displayMob={true} />
      <Toaster position='top-center' reverseOrder={false} />
      <div>
        <div className='container'>
          <div>
            <Link className='page-links' to='/'>
              <FontAwesomeIcon icon='home' />{' '}
            </Link>
            <span className='link-span'>
              <FontAwesomeIcon icon='angle-right' />
            </span>
            <span className='link-span'>PLAN MANAGEMENT</span>
          </div>
          <div className='container'>
            <div className='col-12 d-flex justify-content-between align-items-center my-4'>
              <h4 className='h4 mb-0'>
                PLAN MANAGEMENT <FontAwesomeIcon icon='credit-card' />
              </h4>
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => navigate('/quantila/plans/add')}
                disabled
              >
                <FontAwesomeIcon icon='plus' /> Create Plan
              </button>
            </div>
            <p className='product-subheads'>
              Editing a plan's price or billing cycle rotates its Stripe Price.
              Users already subscribed keep their current price until they
              change plans.
            </p>
            <PlansTable plans={plans} onDeactivate={deactivatePlan} />
          </div>
        </div>
        <FooterProfile />
      </div>
    </>
  );
};

export default Plans;
